import React from 'react'
import trashcan from '../Images/trashcan512x512.png'
import './TrashSpinner.css'

export default function TrashSpinner(props){
    return <img className="trash-spinner" src={trashcan} alt=""></img>
}